import {Trans} from 'react-i18next'

import {Grid} from '@mui/material'
import {PGTypography} from '@progynyglobal/pg-ui-library'
import {makeStyles} from 'tss-react/mui'

import {ReactComponent as FileIcon} from '@progyny/assets/icons/file.svg'
import {ReactComponent as HeartMessageIcon} from '@progyny/assets/icons/heart-message.svg'
import {ReactComponent as MidwifeIcon} from '@progyny/assets/icons/midwife.svg'
import {useConsultationsProgramDetailQuery} from '@progyny/generated/graphql'
import ProgramCard from '@progyny/pages/Consultations/components/ProgramCard'

const useStyles = makeStyles()((theme) => ({
  cardsHeadline: {
    width: '100%',
    maxWidth: '1256px',
    height: '24px',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '24px',
    color: '#251F1F',
    marginBottom: theme.spacing(1),
  },
}))

const P3Overview: React.FC<{
  colors: any
  slug: string
}> = ({colors, slug}) => {
  const {classes} = useStyles()

  const {data: pregnancyProgramData} = useConsultationsProgramDetailQuery({
    variables: {slug: 'pregnancy-support'},
  })

  const pregnancyProgram = pregnancyProgramData?.consultations?.program
  const pregnancyEnrollment =
    pregnancyProgramData?.consultations?.myProgramEnrollments?.find(
      (e) => e?.program?.id === pregnancyProgram?.id
    )
  const session8Status = pregnancyEnrollment?.sessionStatuses?.find(
    (ss) => ss?.session?.sessionNumber === 8
  )
  const isPostpartumLocked = !(
    session8Status?.status === 'BOOKED' ||
    session8Status?.status === 'COMPLETED'
  )

  return (
    <Grid container rowGap={2}>
      <PGTypography className={classes.cardsHeadline} component='h4'>
        <Trans i18nKey='consultations_postpartum_postpartum_consultation_page_your_program' />
      </PGTypography>
      <Grid container spacing={3}>
        <ProgramCard
          slug={`${slug}-support`}
          icon={FileIcon}
          color='dark'
          colors={colors}
          fullWidth
          isFullRow
        />
      </Grid>

      <PGTypography className={classes.cardsHeadline} component='h4' mt={4}>
        <Trans i18nKey='consultations_postpartum_postpartum_consultation_page_additional_suppo' />
      </PGTypography>
      <Grid container spacing={3}>
        <ProgramCard
          slug={`${slug}-emotional-support-program`}
          icon={HeartMessageIcon}
          color='bright'
          colors={colors}
        />
        <ProgramCard
          slug={`${slug}-ask-a-midwife`}
          isAskAMidwife
          icon={MidwifeIcon}
          color='bright'
          colors={colors}
        />
      </Grid>
      {slug === 'pregnancy' && (
        <>
          <PGTypography className={classes.cardsHeadline} component='h4' mt={4}>
            <Trans i18nKey='consultations_pregnancy_pregnancy_consultation_page_postpartum_care_jo' />
          </PGTypography>
          <Grid container spacing={3}>
            <ProgramCard
              slug='postpartum-support'
              icon={FileIcon}
              color='dark'
              colors={colors}
              fullWidth
              locked={isPostpartumLocked}
              isFullRow
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default P3Overview
